var map = {
	"./bg": 170,
	"./bg.webp": 170,
	"./buddy_blank": 171,
	"./buddy_blank.png": 171,
	"./buddy_blank_big": 172,
	"./buddy_blank_big.png": 172,
	"./cowork-preview": 173,
	"./cowork-preview.jpg": 173,
	"./favicon": 174,
	"./favicon.png": 174,
	"./logo_navbar": 175,
	"./logo_navbar.png": 175
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 220;